import { ENVIRONMENT } from 'constants/application/environment'
import { EmbedFrameContext, getEmbedParentOrigin } from './embedParentOrigin'

/** Lifecycle message types of the Propstack technical contract ("Close iFrame" section). */
export enum EmbedParentMessageType {
  /** Broker completed or cancelled the flow; the parent should dismiss the iframe. */
  CLOSE = 'BACKBONE_CLOSE',
}

export interface EmbedParentMessage {
  type: EmbedParentMessageType
}

/**
 * Posts a lifecycle message to the embedding parent page (ISSUE-3101). The contract mandates
 * an explicit targetOrigin, so the message is dropped (returns false) when no allowlisted
 * parent origin can be resolved — it is never posted with '*'.
 */
export const postMessageToEmbedParent = (
  type: EmbedParentMessageType,
  context: EmbedFrameContext,
  environment: string = ENVIRONMENT
): boolean => {
  const targetOrigin = getEmbedParentOrigin(context, environment)
  if (targetOrigin === null) return false
  const message: EmbedParentMessage = { type }
  window.parent.postMessage(message, targetOrigin)
  return true
}
